import { currentSubSession } from '../../subSession/currentSubSession';
import { isMultiSessionEnabled } from '../../subSession/isMultiSessionEnabled';
import { SUB_SESSION_HEADER } from '../../subSession/wireContract';

/**
 * The sub-session header for a backend request, so it carries this tab's confirmed id.
 * Empty until the id is confirmed, so a tab that may be a copy never sends another tab's id,
 * and always empty with `IbeClient.MultiSession.Enabled` off.
 */
export const getSubSessionHeaders = (): Record<string, string> => {
  if (!isMultiSessionEnabled()) {
    return {};
  }

  const subSessionId = currentSubSession();
  return subSessionId ? { [SUB_SESSION_HEADER]: subSessionId } : {};
};
